module.exports = __webpack_public_path__ + "img/colaboracion-services.a112596a.jpg";